import { Tooltip2 } from '@blueprintjs/popover2';
import { getShiftSlotTheme } from '../components/roster-utilities';
import { IRosterShift } from '../types';
import { BookingTypeIcon } from 'common-components/tags';
import moment from 'moment';
import React from 'react';
import { BookingType, ServiceType } from 'utilities/enum-utils';
import { Avatar, Group, Stack, Text } from '@good/ui/core';
import { useBookings } from 'views/bookings-v2/books-view-context/bookings-view-context';
import { ROSTER_TAB } from '../components/roster-common-enums';
import { WorkerShiftStatusBadge } from './worker-shift-status-badge';
import { RosterCard } from './roster-card';
import { CardTime } from './card-time';

interface WorkerShiftCardProps {
  shift: IRosterShift;
  tab: ROSTER_TAB;
  rowIndex?: number;
}

/* This component takes a start/end time, and calculates the position/width within a timeline. */
export function WorkerShiftCard({ shift, tab, rowIndex }: WorkerShiftCardProps) {
  const { shiftStartDateTime, shiftEndDateTime, shiftSlotStatus, serviceName } = shift;
  const mStartDate = moment(shiftStartDateTime);
  const mEndDate = moment(shiftEndDateTime);
  const startTimeDisplay = mStartDate.format('h:mm a');
  const endTimeDisplay = mEndDate.format('h:mm a');
  const { bgColor, borderColor } = getShiftSlotTheme(shiftSlotStatus);
  const onSelectRosterItem = useBookings((selector) => selector.onSelectRosterItem);
  const selectedRosterItem = useBookings((selector) => selector.selectedRosterItem);
  const isSelected = Boolean(
    selectedRosterItem &&
      ((shift.bookingId && selectedRosterItem?.bookingId === shift.bookingId) ||
        ('supportWorkerAttendanceId' in selectedRosterItem &&
          shift.supportWorkerAttendanceId &&
          selectedRosterItem?.supportWorkerAttendanceId === shift.supportWorkerAttendanceId)),
  );
  const name = `${shift.customerFirstName ?? ''} ${shift.customerLastName ?? ''}`;

  return (
    <>
      <RosterCard
        bg={bgColor}
        borderColor={borderColor}
        endDateTime={shift.shiftEndDateTime}
        startDateTime={shift.shiftStartDateTime}
        onSelect={() => onSelectRosterItem({ item: shift, type: 'workerShift', tab })}
        rowIndex={rowIndex}
        selected={isSelected}
        tab={tab}
        topSection={
          <Group wrap='nowrap' gap={8}>
            <WorkerShiftStatusBadge status={shiftSlotStatus} size='sm' />
            {shift.serviceType === ServiceType.INDIVIDUAL && shift.bookingId && (
              <Tooltip2 content={<Text c='white'>{name}</Text>} position={'bottom-right'}>
                <Avatar size={18} name={name} color='initials' />
              </Tooltip2>
            )}
          </Group>
        }
      >
        <div className='whitespace-nowrap text-overflow-ellipsis'>
          <CardTime startTime={startTimeDisplay} endTime={endTimeDisplay} />
          <Group wrap='nowrap' gap={4} align='center'>
            <BookingTypeIcon
              size='xs'
              type={shift.bookingType === BookingType.ACTIVITY_RECORD ? BookingType.ACTIVITY_RECORD : shift.serviceType}
            />
            <Text size='sm'>{serviceName}</Text>
          </Group>
        </div>
      </RosterCard>
    </>
  );
}
